var config = {};
var setConfig = function (customConfig) {
    return (config = Object.assign(config, customConfig));
};
var PLUGIN_NAME = 'code_block';
export { config, PLUGIN_NAME, setConfig };
//# sourceMappingURL=config.js.map